import { useLazyUserRelationsQuery } from '../../../graphql/graphql';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';

export enum HealthPlanRelation {
	MEDDI_DIABETES = 3,
	MEDDI_BABY = 4,
}

export default function useUserRelations() {
	const [getUserRelations] = useLazyUserRelationsQuery();
	const getData = async (patientId: string, workplaceId: string) => {
		return await getUserRelations({
			userId: patientId,
			workplaceId,
			useOriginalId: true,
		}).unwrap();
	};

	const getHealthPlanDoctorId = async (
		patientId: string,
		workplaceId: string,
		healthPlanType: HealthPlanRelation,
	) => {
		const data = await getData(patientId, workplaceId);
		return data?.user?.userRelations?.find(
			({ type }: any) => type === healthPlanType,
		)?.relationUserId;
	};

	const getHealthPlanRelationCodeByHealthPlanCode = (
		healthPlanCode: HealthPlanCode,
	) => {
		if (healthPlanCode === HealthPlanCode.BABY) {
			return HealthPlanRelation.MEDDI_BABY;
		}
		if (healthPlanCode === HealthPlanCode.DIABETES) {
			return HealthPlanRelation.MEDDI_DIABETES;
		}
		return null;
	};

	return { getHealthPlanDoctorId, getHealthPlanRelationCodeByHealthPlanCode };
}
